"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.075 4.083 9.696 7.396c.305.233.305.81 0 1.042l-9.696 7.396c-.307.234-.693-.056-.693-.521V4.604c0-.465.386-.756.694-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m3.694 4.083 9.695 7.396c.306.233.306.81 0 1.042l-9.695 7.396C3.386 20.15 3 19.86 3 19.396V4.604c0-.465.386-.756.694-.52Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FastForwardIcon24.js.map